<div class="row" *ngIf="uploaderStyle === 'dropzone'">
  <div class="col-md-12">
    <nz-upload
      class="uploader"
      nzType="drag"
      [nzDisabled]="readOnly"
      [nzShowUploadList]="false"
      [nzMultiple]="true"
      [nzCustomRequest]="uploadFile"
      (nzChange)="handleChange($event)"
    >
      <i class="fi fi-br-gallery"></i>

      <p class="ant-upload-text" *ngIf="!message">Click, tap or drag a {{type}} to this area to upload</p>
      <p class="ant-upload-text" *ngIf="message">{{message}}</p>
      <p class="ant-upload-hint" *ngIf="type === 'image'">
        Only images files are allowed, maximum size 4MB.
      </p>
      <p class="ant-upload-hint mb-0" *ngIf="type === 'media'">
        Any video or image format allowed up to 100MB
      </p>
    </nz-upload>

    <div [hidden]="!($uploading | async)" class="uploading bg-grad-theme">
      <h3>Uploading...</h3>
    </div>

  </div>

  <div class="col-md-12">

    <div class="d-flex flex-wrap mt-10 ">
      <div class="uploaded-image-container mb-5 mb-md-0" *ngFor="let item of value; let i = index;">

        <a class="image-inner-container" *ngIf="isImage(item)" [href]="item" target="_blank" [style.background-image]="'url(' + item + ')'">

        </a>
        <a class="image-inner-container" *ngIf="!isImage(item)" [href]="item" target="_blank">
          <span class="play-icon">
            <i class="fi fi-br-play"></i>
          </span>
        </a>
        <button class="remove-button btn btn-danger w-full btn-sm" (click)="removeFile(i)">Remove</button>

      </div>
    </div>


  </div>

</div>



<ng-container *ngIf="uploaderStyle === 'input'">
  <input #fileInput type="file" (change)="onFileInput($event)" style="display:none;"/>

  <div *ngIf="type === 'document'">
    <a class="file-preview bg-light-theme d-inline-flex align-items-center mb-3" *ngIf="value && value.length" [href]="value[0]" target="_blank">
      <i class="fi fi-br-file me-2"></i> Uploaded File <i (click)="removeFile(0)" class="fi fi-br-cross-circle ms-3 remove-doc"></i>
    </a>
  </div>

  <div class="d-flex align-items-center" *ngIf="type === 'image'">
    <div class="me-3" *ngIf="value && value.length">
      <img class="preview" [src]="value[0]">
    </div>
    <div class="align-items-end">
      <button type="button" class="btn btn-outline-theme" (click)="fileInput.click()"><i class="fi fi-br-upload me-2"></i>
        <span *ngIf="(!value || !value.length)">Upload a file</span>
        <span *ngIf="(value && value.length)">Change file</span>
      </button>
      <p class="mb-0 mt-2" *ngIf="type === 'image'"><small>JPG, GIF, PNG, SVG, Max Size 1MB</small></p>
      <p class="mb-0 mt-2" *ngIf="type !== 'image'"><small>Word, Excel, PPT, PDF, Max Size 10MB</small></p>
    </div>

  </div>
</ng-container>

